import EvenOddListSectionProps from '@/v2/components/sections/landing-pages/even-odd-section'
import FaqSection from '@/v2/components/sections/landing-pages/faq-section'
import GridSection from '@/v2/components/sections/landing-pages/grid-section'
import HelperGuideSection from '@/v2/components/sections/landing-pages/helper-guide-section'
import HeroSection from '@/v2/components/sections/landing-pages/hero-section'
import InfoBannerSection from '@/v2/components/sections/landing-pages/info-banner-section'
import WhyChooseUsSection from '@/v2/components/sections/landing-pages/why-choose-us-section'
import {
  evenOddList,
  faqSectionContent,
  gridSectionContent,
  helperGuideSection,
  heroSectionContent,
  infoBannerSectionContent,
  whyChooseUsSectionContent,
  whyStorageSectionContent
} from '@/v2/constants/pages/landing-pages/moving-and-storage-discounts-page'

interface MovingAndStorageDiscountsPageProps {}

const MovingAndStorageDiscountsPage: React.FC<MovingAndStorageDiscountsPageProps> = () => {
  return (
    <>
      <HeroSection {...heroSectionContent} />
      <HelperGuideSection {...helperGuideSection} />
      <WhyChooseUsSection {...whyStorageSectionContent} />
      <GridSection {...gridSectionContent} />
      <EvenOddListSectionProps {...evenOddList} />
      <HelperGuideSection {...whyChooseUsSectionContent} />
      <InfoBannerSection card={infoBannerSectionContent} ctaButton={infoBannerSectionContent.ctaButton} />
      <FaqSection {...faqSectionContent} />
    </>
  )
}

export default MovingAndStorageDiscountsPage
